import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "../styles/delete-task-modal.css";

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    taskTitle?: string;
    /** Shown before the bold name (e.g. "Task", "Resource"). Defaults to "Task". */
    itemLabel?: string;
};

export default function DeleteTaskModal({ open, onClose, onConfirm, taskTitle, itemLabel = "Task" }: Props) {
    // Close modal on Escape key
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (open && e.key === "Escape") {
                onClose();
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    return createPortal(
        <div className="delete-modal-backdrop">
            <div className="delete-modal" role="dialog" aria-modal="true" aria-labelledby="delete-task-title">
                <div className="delete-modal-header">
                    <h2 id="delete-task-title">Permanently Delete?</h2>
                    <button className="delete-modal-close" onClick={onClose} aria-label="Close">
                        ×
                    </button>
                </div>

                <div className="delete-modal-content">
                    <div className="delete-warning-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                            <line x1="12" y1="9" x2="12" y2="13"/>
                            <line x1="12" y1="17" x2="12.01" y2="17"/>
                        </svg>
                    </div>

                    {taskTitle && (
                        <p className="delete-task-name">
                            {itemLabel}: <strong>{taskTitle}</strong>
                        </p>
                    )}

                    <p className="delete-warning-text">
                        Just checking, are you sure you want to delete this? Once it's gone, you won't be able to get it back.
                    </p>

                    <div className="delete-modal-actions">
                        <button className="delete-cancel-btn" onClick={onClose}>
                            No, cancel
                        </button>
                        <button className="delete-confirm-btn" onClick={onConfirm}>
                            Yes, delete
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}